// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"262":"17116c41","937":"78312871"}[chunkId] + ".chunk.js";
};